import { render, staticRenderFns } from "./MaterialDashboardTable.vue?vue&type=template&id=091bdb40&scoped=true&"
import script from "./MaterialDashboardTable.vue?vue&type=script&lang=js&"
export * from "./MaterialDashboardTable.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDashboardTable.vue?vue&type=style&index=0&id=091bdb40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091bdb40",
  null
  
)

export default component.exports